import * as React from 'react';
import { Edit, AttachMoney, Visibility, Warning } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { APPLICATION_CARD_INFO_TEXT, CARD_PAGE_TEXT } from './lang';
import './ApplicationCard.css';
import { APPLICATION_MODULE } from '../ApplicationForm';
import { IconButton } from '../../../../components';
import {
  APPLICATION_STATUS_TYPE,
  APPLICANT_STATUS_DISPLAY_MAP,
} from '../../../../utils/statusConstants/statusConstants';

type ApplicationCardInfoProps = {
  status: APPLICATION_STATUS_TYPE; // Define the type of the 'status' prop
  applicationId: string;
  needsDeclaration: boolean;
};

export const ApplicationCardInfo: React.FunctionComponent<
  ApplicationCardInfoProps
> = (props: ApplicationCardInfoProps) => {
  const { status, applicationId, needsDeclaration } = props;

  // TODO: change the status string to enum
  const handleIconDisplay = (
    status: APPLICATION_STATUS_TYPE,
  ): React.ReactNode => {
    switch (status) {
      case APPLICATION_STATUS_TYPE.CREATED:
      case APPLICATION_STATUS_TYPE.RETURNED:
        return <Edit />;
      case APPLICATION_STATUS_TYPE.APPLICATION_FEE_PENDING:
      case APPLICATION_STATUS_TYPE.REGISTRATION_FEE_PENDING:
        return <AttachMoney />;
      default:
        return <Visibility />;
    }
  };

  const navigate = useNavigate();

  const handleEnterApplication = (): void => {
    const displayApplicationProgress =
      status !== APPLICATION_STATUS_TYPE.CREATED && Boolean(status);
    const defaultActivatedWithoutParam = displayApplicationProgress
      ? APPLICATION_MODULE.APPLICATION_PROGRESS
      : APPLICATION_MODULE.PROGRAMME_CHOICES;

    navigate(
      `/application/${applicationId}?apsb=${defaultActivatedWithoutParam}`,
    );

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDeclaration = (): void => {
    navigate(`/application/make-up-declaration/${applicationId}`);
  };

  return (
    <div>
      <div className="card-info">
        <div className="info-block">
          <div className="flex" style={{ alignItems: 'center' }}>
            <div className="submission-status">
              {APPLICANT_STATUS_DISPLAY_MAP[status]}
            </div>
            {needsDeclaration && (
              <IconButton
                icon={<Warning />}
                onClick={handleDeclaration}
                title={APPLICATION_CARD_INFO_TEXT.DECLARATION_REQUIRED}
                color="primary"
                aria-label={CARD_PAGE_TEXT.EDIT}
              />
            )}

            <IconButton
              icon={handleIconDisplay(status)}
              onClick={handleEnterApplication}
              color="primary"
              aria-label={CARD_PAGE_TEXT.EDIT}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
